var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "42.3783mm",
    height: "71.4831mm",
    viewBox: "0 0 3500.23 5904.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 209.79,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M1638.36 1730.54c732.4,0 1326.13,593.73 1326.13,1326.13 0,732.4 -593.73,1326.13 -1326.13,1326.13 -732.4,0 -1326.14,-593.73 -1326.14,-1326.13 0,-732.4 593.73,-1326.13 1326.14,-1326.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CB482",
    stroke: "white",
    strokeWidth: 111.89,
    strokeMiterlimit: 22.9256,
    d: "M1471.9 3462.49c-361.2,690.44 -917.51,1500.41 -1273.22,2181.9l352.65 -325.82c117.17,-114.01 221.26,-204.32 332.91,-314.03l1689.74 -1616.24c93.22,-87.4 253.86,-228.66 328.62,-325.37l-1090.1 -293.3 1348.11 -2300.69c-38.24,43.29 -119.8,109.35 -171.23,158.4l-1935.94 1858.76c-123.18,117.17 -230.03,221.58 -351.92,338.33 -93.85,89.91 -290.87,258.54 -348.97,347.96l1119.35 290.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.873ccf1855a130ab26c2c339a5c5630f.svg";
export { ForwardRef as ReactComponent };